/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios"
import { IFascicolo, IQueryCriteriaEF, IPaginatedDataEF_Response } from "../shared/interfaces";


const controller = 'ProtocolliFascicoli';


const getProtocolliDelFascicolo = (aooId: number, uorId: number, fascicoloId: number, paginatedDataRequest: IQueryCriteriaEF, cancelToken?: CancelToken): Promise<IPaginatedDataEF_Response> => {
    return axiosInstance.post(`${controller}/${aooId}/${uorId}/GetProtocolliDelFascicolo/${fascicoloId}`, paginatedDataRequest, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });

}

const getFascicoliDelProtocollo = (aooId: number, protocolId: number, uorId?: number, cancelToken?: CancelToken): Promise<IFascicolo[]> => {
    return axiosInstance.get(`${controller}/${aooId}/GetFascicoliDelProtocollo/${protocolId}`, { cancelToken: cancelToken, params: { uorId: uorId } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        })
}

const addProtocolToFascicolo = (aooId: number, uorId: number, protocolId: number, fascicoloId: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.get(`${controller}/${aooId}/${uorId}/AggiungiProtocolloAlFascicolo`, { cancelToken: cancelToken, params: { protocolId, fascicoloId } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const rimuoviProtocolloDalFascicolo = (aooId: number, uorId: number, protocolId: number, fascicoloId: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.delete(`${controller}/${aooId}/${uorId}/RimuoviProtocolloDalFascicolo`, { cancelToken: cancelToken, params: { protocolId, fascicoloId } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });

}

export default {
    getProtocolliDelFascicolo,
    getFascicoliDelProtocollo,
    addProtocolToFascicolo,
    rimuoviProtocolloDalFascicolo
}